module.exports = __webpack_public_path__ + "more_vert.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/more_vert.svg
// module id = FfM6
// module chunks = 0